export enum Classification {
    C1 = 'C1',
    C2 = 'C2',
    C3 = 'C3',
    C4 = 'C4'
}